module.exports = __webpack_public_path__ + "static/img/hand.38f8627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fivep/hand.png
// module id = JEjc
// module chunks = 1